

export const index = 8;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/ueber-mich/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/8.B0QXNrtL.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DuUomSZU.js"];
export const stylesheets = ["_app/immutable/assets/8.DZie7HXk.css"];
export const fonts = [];
